import React, { useState } from 'react';
import { ViewDetailsIcon } from '../../../assets/icons';
import { Modal } from '../../shared';

export function BookingUtils(props: { row: any }) {
  const row = props.row;
  //STATES
  const [isImagesModal, setIsImagesModal] = useState<boolean>(false);
  const [images] = useState([...row?.row?.images]);
  return (
    <React.Fragment>
      <div className='flex flex-col'>
        {/* View Details */}
        <button
          className='hover:cursor-pointer  transition-all duration-300 rounded-[4px] hover:bg-gray-200 p-2 flex justify-start items-start gap-2'
          onClick={() => setIsImagesModal(true)}
        >
          <ViewDetailsIcon className='w-[20px] h-[20px]' />
          View Images
        </button>
      </div>
      <Modal
        open={isImagesModal}
        onClose={() => {
          setIsImagesModal(false);
        }}
        title='Booking Images'
      >
        <ImageSlider images={images} />
      </Modal>
    </React.Fragment>
  );
}

interface ImageSliderProps {
  images: { Location: string }[];
  width?: string; // e.g. '500px'
}

const ImageSlider: React.FC<ImageSliderProps> = ({ images, width = '500px' }) => {
  const [current, setCurrent] = useState(0);
  const nextImage = () => setCurrent(prev => (prev + 1) % images.length);
  const prevImage = () => setCurrent(prev => (prev - 1 + images.length) % images.length);

  return (
    <div className='relative flex items-center justify-center bg-[#0F0F0F]/5 rounded-xl overflow-hidden min-w-lg min-h-[400px]'>
      {images.length > 0 ? (
        <>
          <img
            src={images[current].Location}
            alt={`Slide ${current + 1}`}
            className='w-full h-full object-contain rounded-lg transition-all duration-300'
          />

          {/* Left Arrow */}
          <button
            onClick={prevImage}
            className='absolute left-3 bg-black/40 hover:bg-black/60 text-white p-2 rounded-full transition'
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
              strokeWidth={2}
              stroke='currentColor'
              className='w-5 h-5'
            >
              <path strokeLinecap='round' strokeLinejoin='round' d='M15 19l-7-7 7-7' />
            </svg>
          </button>

          {/* Right Arrow */}
          <button
            onClick={nextImage}
            className='absolute right-3 bg-black/40 hover:bg-black/60 text-white p-2 rounded-full transition'
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
              strokeWidth={2}
              stroke='currentColor'
              className='w-5 h-5'
            >
              <path strokeLinecap='round' strokeLinejoin='round' d='M9 5l7 7-7 7' />
            </svg>
          </button>

          {/* Image counter */}
          <div className='absolute bottom-2 right-3 bg-black/50 text-xs text-white px-2 py-1 rounded-md'>
            {current + 1} / {images.length}
          </div>
        </>
      ) : (
        <p className='text-gray-400 text-sm'>No images available</p>
      )}
    </div>
  );
};

export default ImageSlider;
